import React, { useState } from "react";
import CollectionItem from "./../collections/collection-item";
import MyBookmarksGroupedByLayout from "./my-bookmarks-groups-by-layout";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import SearchBookmarks from "./options/search-bookmarks";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import AddUserCollectionModal from "../user-collections/add-user-collection-modal";
import useBookmarkGroups from "utilities/hooks/queries/my-link/bookmarks/grouped/use-bookmark-groups-query";
import UserCollectionShareType from "models/enumerations/user-collection-share-type";
import useFilterCollectionShareType from "utilities/hooks/domain/my-link/use-filter-collection-share-type";
import FilterByCollectionShareType from "./options/filter-by-collection-share-type";
import EmptyMyLinkPanel from "organisms/my-link/empty-mylink-panel";
import { CollectionUtils } from "@rsm-hcd/javascript-core";
import useSortBookmarkCounts from "utilities/hooks/domain/my-link/use-sort-bookmark-counts";
import BookmarkCountSortBy from "./options/bookmark-count-sort-by";
import { t } from "utilities/localization-utils";

const MyBookmarksViewByCollection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { onSortByChange, sortBy } = useSortBookmarkCounts(
        UserBookmarkCountBy.Collection
    );
    const { onSearchTextChange, searchText } = useSearchBookmarks(
        UserBookmarkCountBy.Collection
    );
    const { onCollectionShareTypeChange, collectionShareType } =
        useFilterCollectionShareType(UserBookmarkCountBy.Collection);
    const { bookmarkGroups, isLoadingCounts, refetchBookmarkGroups } =
        useBookmarkGroups(UserBookmarkCountBy.Collection, {
            bookmarksCreatedByMe: false,
            searchText: searchText,
            sortOption: sortBy,
            collectionShareType:
                collectionShareType == null
                    ? undefined
                    : (collectionShareType as UserCollectionShareType),
        });

    const handleModalOpen = () => setIsModalOpen(true);
    const handleModalClose = async () => {
        await refetchBookmarkGroups();
        setIsModalOpen(false);
    };

    return (
        <MyBookmarksGroupedByLayout
            countBy={UserBookmarkCountBy.Collection}
            dropdowns={
                <>
                    <FilterByCollectionShareType
                        onChange={onCollectionShareTypeChange}
                        collectionShareType={
                            collectionShareType as UserCollectionShareType
                        }
                    />
                    <BookmarkCountSortBy
                        onChange={onSortByChange}
                        sort={sortBy}
                        showCollection={true}
                    />
                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                        placeHolder={t(
                            "myBookmarksTabFilters-searchCollection-placeholder"
                        )}
                    />
                </>
            }>
            <>
                <Button
                    dataTestId="my-link--my-bookmarks-view-by-collection--new-collection-button"
                    cssClassName="-icon-left"
                    onClick={handleModalOpen}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Tertiary}>
                    <Icon type={Icons.Plus} />
                    {"Create New Collection"}
                </Button>
                {!isLoadingCounts &&
                    (CollectionUtils.hasValues(bookmarkGroups) ? (
                        bookmarkGroups?.map((collectionGroup) => (
                            <CollectionItem
                                key={collectionGroup.id}
                                bookmarkCount={collectionGroup}
                                onUpdateCollection={refetchBookmarkGroups}
                            />
                        ))
                    ) : (
                        <EmptyMyLinkPanel />
                    ))}
            </>
            <AddUserCollectionModal
                closeDialog={handleModalClose}
                isVisible={isModalOpen}
            />
        </MyBookmarksGroupedByLayout>
    );
};

export default MyBookmarksViewByCollection;
